import { getCookieValue } from '@lingoda/cookie';

/**
 * Snapshot of the four Google consent-mode signals, normalized from the CMP.
 * `null` means "signal could not be read" (CMP cookie absent or category missing):
 * consumers must treat it as "consent not proven", never as a refusal.
 */
export interface ConsentSnapshot {
    readonly consentAdStorage: boolean | null;
    readonly consentAnalyticsStorage: boolean | null;
    readonly consentAdUserData: boolean | null;
    readonly consentAdPersonalization: boolean | null;
}

const COOKIEYES_CONSENT_COOKIE_NAME = 'cookieyes-consent';

const readCategory = (rawCookie: string, category: string): boolean | null => {
    const entry = rawCookie.split(',').find((part) => part.startsWith(`${category}:`));

    if (!entry) {
        return null;
    }

    const value = entry.slice(category.length + 1);

    if (value === 'yes') {
        return true;
    }

    if (value === 'no') {
        return false;
    }

    return null;
};

export const getConsentSnapshot = (): ConsentSnapshot => {
    const rawCookie = getCookieValue(COOKIEYES_CONSENT_COOKIE_NAME);

    if (!rawCookie) {
        return {
            consentAdStorage: null,
            consentAnalyticsStorage: null,
            consentAdUserData: null,
            consentAdPersonalization: null,
        };
    }

    const analytics = readCategory(rawCookie, 'analytics');
    const advertisement = readCategory(rawCookie, 'advertisement');

    return {
        consentAdStorage: advertisement,
        consentAnalyticsStorage: analytics,
        consentAdUserData: advertisement,
        consentAdPersonalization: advertisement,
    };
};
